import React from 'react';
import './Weather.css'

import {
  inject,
  observer
} from 'mobx-react';

import Spinner from '../../components/Spinner/Spinner.js';
import WeatherGraph from '../../components/WeatherGraph/WeatherGraph.js';
import WeatherNav from '../../components/WeatherNav/WeatherNav.js';

import getWeather from '../../requests/getWeather';
import { getDayNameShort } from '../../utils/datetime.js';
import { setBackground } from '../../utils/style.js';
import { get3HourIntervalWeather } from '../../utils/weather';

let resizeTimeout;

class Weather extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeDayIndex: 0,
      graphWidth: 0,
      graphHeight: 0,
      upcomingHours: undefined
    }
  }

  render() {
    return (
      <div className='weather'>
        <div className='weather__top'>
          {this.props.weatherStore && this.props.weatherStore.days ?
            <div className='weather__summary'>
              <strong className='weather__summary-title'>Summary:</strong>
              <span className='weather__summary-text'>
                {this.props.weatherStore.days[this.state.activeDayIndex].summary}
              </span>
            </div>
          : null}
        </div>
        <div ref='graph' className='weather__graph'>
          {this.state.upcomingHours ?
            <WeatherGraph
              height={this.state.graphHeight}
              width={this.state.graphWidth}
              points={this._getGraphPointsFromHours(this.state.upcomingHours)}
          />
            : <Spinner/>}
        </div>
        <div className='weather__nav'>
          {this.props.weatherStore && this.props.weatherStore.days ?
            <WeatherNav
              days={this.props.weatherStore.days.map((day, index) => ({
                dayName: getDayNameShort(new Date(day.time * 1000)),
                icon: day.icon,
                id: day.time,
                index: index,
                isActive: this.state.activeDayIndex === index,
                temperatureMax: day.temperatureMax,
                temperatureMin: day.temperatureMin,
              })).filter((day, index) => index < 7)}
              onChange={this.onDayChange}
            />
          : null}
        </div>
      </div>
    );
  }

  componentWillMount() {
    setBackground('green');
    window.addEventListener('resize', this._updateGraphSizeTimeout);
    this.props.weatherStore.onLoad(weatherStore => {
      this.setState({
        upcomingHours: weatherStore.upcomingHours,
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._updateGraphSizeTimeout);
  }

  componentDidMount() {
    this._updateGraphSize();
  }

  onDayChange = (index) => {
    const time = this.props.weatherStore.days[index].time;

    this.setState({
      activeDayIndex: index,
      upcomingHours: undefined,
    }, () => {
      getWeather((weather) => {
        this.setState({
          upcomingHours: weather.hourly.data
        });
      }, {
        time: time
      });
    });

  }

  _getGraphPointsFromHours = (hours) => {
    return get3HourIntervalWeather(hours, 8).map(hour => ({
      temperature: Math.round(hour.temperature),
      time: new Date(hour.time * 1000),
    }))
  }

  _updateGraphSize = () => {
    const graph = this.refs.graph;
    this.setState({
      graphWidth: window.innerWidth,
      graphHeight: Math.min(graph.clientHeight, 320),
    });
  }

  _updateGraphSizeTimeout = () => {
    window.clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(() => {
      this._updateGraphSize();
    }, 500);
  }
};

export default inject('weatherStore')(observer(Weather));



// WEBPACK FOOTER //
// ./src/views/Weather/index.js